import React from 'react';
import { ChevronUp, Megaphone, Pause, Play } from 'lucide-react';
import { Button } from './ui/button';

function AdBanner({ ads, activeAd, onExpand, paused, onTogglePaused }) {
  if (!ads?.length || !activeAd) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[70] border-t border-slate-200 bg-white/95 px-2 py-2 backdrop-blur-xl">
      <div className="mx-auto flex max-w-5xl items-center gap-2 rounded-xl border border-slate-200 bg-white px-2 py-2 shadow-lg">
        <button
          type="button"
          onClick={onExpand}
          className="group flex min-w-0 flex-1 items-center gap-2 rounded-lg px-2 py-1 text-left transition hover:bg-emerald-50"
          data-testid="ad-banner-expand"
          aria-label="Ouvrir la publicite"
        >
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
            <Megaphone className="h-4 w-4" />
          </div>
          <div className="min-w-0 overflow-hidden">
            <div className="ad-ticker-track whitespace-nowrap text-xs font-semibold text-slate-700">
              {ads.map((ad, index) => (
                <span key={ad.id} className="mr-10 inline-block">
                  {index + 1}. {ad.sponsor}: {ad.title}
                </span>
              ))}
            </div>
            <p className="truncate text-[11px] text-slate-500">Touchez pour ouvrir le spot interactif</p>
          </div>
        </button>

        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onTogglePaused}
          className="h-9 w-9 p-0"
          data-testid="ad-banner-toggle"
          title={paused ? 'Relancer le defilement' : 'Mettre en pause'}
        >
          {paused ? <Play className="h-4 w-4" /> : <Pause className="h-4 w-4" />}
        </Button>

        <Button
          type="button"
          size="sm"
          onClick={onExpand}
          className="h-9 bg-emerald-600 px-3 text-white hover:bg-emerald-700"
          data-testid="ad-banner-open"
        >
          <ChevronUp className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}

export default AdBanner;
